import { toast } from "react-toastify";
import { GetAllCategoryApi } from "../../../Api/Store/Category";

export const GetAllCategory = (data) => {
  return {
    type: "get_all_category",
    payload: data,
    loader: false,
  };
};

export function getallCategory() {
  return async (dispatch) => {
    try {
      const result = await GetAllCategoryApi();

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllCategory(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch Categories");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching Categories!");
    }
  };
}
